



































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch, PropSync } from 'vue-property-decorator';
import * as FORM_INTERFACE from '../interfaces/accessTicket.interface';
import * as rules from '@/modules/shared/shared/domain/rules';

@Component({
    components: {},
})
export default class AccessCar extends Vue {
    rules: any = rules;

    @PropSync('oldAccessCar', {
        default: () => {
            return {} as FORM_INTERFACE.accessCarsInterface;
        },
    })
    accessCar!: FORM_INTERFACE.accessCarsInterface;

    @Prop()
    index!: number;

    @Prop({ default: '' })
    numberPlateForValidation!: string;

    sendData() {
        return this.accessCar;
    }

    emitNumberPlate(value: string) {
        if (this.index == 1) {
            this.$emit('validateNumberPlate', this.accessCar.numberPlate);
        }
    }
}
